/* unplugin-vue-components disabled */import script from "./CompanyConfirm.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyConfirm.vue?vue&type=script&setup=true&lang=js"

import "./CompanyConfirm.vue?vue&type=style&index=0&id=ab0546b6&lang=css"
import "./CompanyConfirm.vue?vue&type=style&index=1&id=ab0546b6&lang=scss&scoped=true"
import "./CompanyConfirm.vue?vue&type=style&index=2&id=ab0546b6&lang=css"

import exportComponent from "/Users/yaogengzhu/Documents/soft-open/software-platform/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab0546b6"]])

export default __exports__